<script setup>

const route = useRoute();

const props = defineProps({
  name: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  toLink: {
    type: String,
    required: false,
  },
});
</script>
<template>

    <NuxtLink :to="toLink" class="flex items-center justify-between px-4 bg-brand-card h-20 rounded-md cursor-pointer" :class="route.path === toLink ? 'md:bg-brand-primary' : ''">
                  
          <div class="flex items-center gap-3">
              <Icon :name="icon" size="16"/>
              <p>
                  {{name}}
              </p>
          </div>
          <Icon name="fa6-solid:chevron-right" size="10"/>

    </NuxtLink>
    
</template>